export default {"src":"/_next/static/media/chevron-left-circle-fill.c0aff14c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};